"use client";

import { Link, Navbar } from "@nextui-org/react";
import { Neu21Logo } from "./Icons";

export default function NavBar() {
  return (
    <Navbar className="w-full">
      <div className="p-4 flex flex-row items-center">
        <Link
          isExternal
          aria-label="Testra Super"
          href="https://www.telstrasuper.com.au/"
        >
          <Neu21Logo />
        </Link>
        <div className="bg-gradient-to-br from-sky-300 to-indigo-500 bg-clip-text ml-4">
          <p className="text-xl font-semibold text-transparent">
            Neu21 - Putting the Human in the Loop
          </p>
        </div>
      </div>
    </Navbar>
  );
}
